import React from 'react';
import Nav from 'react-bootstrap/Nav';
import ActiveLink from '@bfly/ui/ActiveLink';

const NavLink = (props) => <ActiveLink {...props} as={Nav.Link} />;

export default NavLink;
